// import React from 'react'

import { GA4_MEASUREMENT_ID } from '@shared/constants'
import useOnMouseAndScroll from '@shared/hooks/useOnMouseAndScroll'
import { injectScript } from '@shared/utils'
import { useEffect } from 'react'

export default function GTag() {
  const { isLoaded } = useOnMouseAndScroll()
  useEffect(() => {
    if (isLoaded) {
      injectScript(`https://www.googletagmanager.com/gtag/js?id=${GA4_MEASUREMENT_ID}`).then(() => {
        window.dataLayer = window.dataLayer || []
        window.gtag = function gtag() {
          window.dataLayer.push(arguments)
        }
        window.gtag('js', new Date())
        window.gtag('config', GA4_MEASUREMENT_ID)
      })
    }
  }, [isLoaded])
  return null
}
